<template>
    <nav class="navbar is-fixed-top is-light has-shadow">
        <div class="container is-fluid">
            <div class="navbar-brand">
                <b-dropdown aria-role="menu" mobile-modal>
                    <a class="navbar-item" slot="trigger" role="button">
                        <b-icon icon="menu"></b-icon>
                    </a>
                    <b-dropdown-item v-for="menu in menus" v-bind:key="menu.Id" value="home" aria-role="menuitem" has-link>
                        <router-link :to="menu.menus[0].pathMenu">
                            <i v-html="menu.menus[0].iconMenu">{{menu.menus[0].iconMenu}}</i>{{menu.menus[0].textMenu}}
                        </router-link>
                    </b-dropdown-item>
                    <hr class="dropdown-divider" aria-role="menuitem" />
                    <b-dropdown-item value="logout" aria-role="menuitem">
                        <router-link to="/logout">
                            <b-icon icon="logout"></b-icon>Logout
                        </router-link>
                    </b-dropdown-item>
                </b-dropdown>
                <img src="../assets/logo_bessac.svg" alt="Bessac" />
            </div>
        </div>
    </nav>
</template>
<script>
    export default {
        name: 'Nav',
        data() {
            return {
                menus: []
            }
        },
        mounted: function () {
            this.getMenu();
        },
        methods: {
            getMenu() {
                try {
                    this.axios
                        .get('/menu?idRol=' + localStorage.getItem('role'))
                        .then(response => {
                            const genericResponse = response.data;

                            if (genericResponse.isError == true) {
                                this.$buefy.notification.open({
                                    message: genericResponse.messageError,
                                    position: 'is-top',
                                    type: 'is-danger',
                                    hasIcon: true
                                });
                                return;
                            }

                            this.menus = genericResponse.result;

                        })
                        .catch(error => {
                                this.$buefy.notification.open({
                                    message: error.response.data,
                                    position: 'is-top',
                                    type: 'is-danger',
                                    hasIcon: true,
                                });
                        })
                } catch (e) {
                    console.error(e.message);
                    this.$buefy.notification.open({
                        message: e.response.data,
                        position: 'is-top',
                        type: 'is-danger',
                        hasIcon: true,
                    });
                }
            }
        }
    }
</script>
<style lang="scss">

    .avatar {
        border-radius: 50%;
    }

    .navbar.is-fixed-bottom,
    .navbar.is-fixed-top {
        z-index: 3000;
    }

    .navbar.has-shadow {
        box-shadow: 0 3px 3px #d9d9d9;
    }
</style>